module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_search-ea89787e9724697298e13fc7ca22a8e7.svg";